import { create } from "zustand";

/**
 * Liveness do WebSocket de status de relatórios (`/reports/ws/snap-status/{user_id}`).
 *
 * Guarda apenas se o socket está entregando eventos — nunca dado de relatório.
 * Consumido para decidir se o refetch por tempo é necessário: com socket vivo, as
 * transições de status (e a invalidação de detalhes que as segue) chegam por evento.
 */
interface ReportStatusSocketActions {
    setConnected: (connected: boolean) => void;
}

interface ReportStatusSocketState {
    connected: boolean;
    actions: ReportStatusSocketActions;
}

export const useReportStatusSocketStore = create<ReportStatusSocketState>((set) => ({
    connected: false,
    actions: {
        setConnected: (connected) =>
            set((state) => (state.connected === connected ? state : { connected })),
    },
}));

export const useIsReportStatusSocketConnected = (): boolean =>
    useReportStatusSocketStore((state) => state.connected);
